document.addEventListener("DOMContentLoaded", function () {
  if (typeof algoliasearch === "undefined") {
    console.error("FATAL: Library algoliasearch BELUM dimuat!");
    return;
  }
  if (!window.algoliaShopify || !window.algoliaShopify.config) {
    console.error("FATAL: window.algoliaShopify.config tidak ditemukan.");
    return;
  }

  const algoliaConfig = window.algoliaShopify.config;
  const ALGOLIA_APP_ID = algoliaConfig.app_id;
  const ALGOLIA_SEARCH_API_KEY = algoliaConfig.search_api_key;
  const ALGOLIA_PRODUCTS_INDEX_NAME =
    algoliaConfig.default_index ||
    (algoliaConfig.index_prefix
      ? algoliaConfig.index_prefix + "products"
      : "shopify_products");
  const SHOPIFY_SEARCH_URL = algoliaConfig.routes_search_url || "/search";

  if (
    !ALGOLIA_APP_ID ||
    !ALGOLIA_SEARCH_API_KEY ||
    !ALGOLIA_PRODUCTS_INDEX_NAME
  ) {
    console.error("FATAL: Kredensial Algolia tidak lengkap.");
    return;
  }

  const searchInputElement = document.getElementById("baltini-manual-search");
  if (!searchInputElement) {
    console.error(
      "FATAL: Elemen input #baltini-manual-search tidak ditemukan."
    );
    return;
  }

  const searchFormElement = searchInputElement.closest("form"); // Dapatkan form terdekat
  if (!searchFormElement) {
    console.error("FATAL: Form untuk #baltini-manual-search tidak ditemukan.");
    // Anda bisa memilih untuk return di sini jika form sangat krusial,
    // atau biarkan sisa fungsionalitas berjalan jika form tidak ada (meskipun aneh).
    // Untuk sekarang, kita akan log error saja.
  }

  const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
  const index = searchClient.initIndex(ALGOLIA_PRODUCTS_INDEX_NAME);
  const resultsContainerId = "manual-search-results-display";

  const ALL_COLLECTION_MAPPINGS_FROM_JS = {
    ...(window.MEN_CATEGORY_COLLECTION_MAPPING || {}),
    ...(window.MEN_SUBCATEGORY_COLLECTION_MAPPING || {}),
    ...(window.WOMEN_CATEGORY_COLLECTION_MAPPING || {}),
    ...(window.WOMEN_SUBCATEGORY_COLLECTION_MAPPING || {}),
    ...(window.BOYS_COLLECTION_MAPPING || {}),
    ...(window.GIRLS_COLLECTION_MAPPING || {}),
  };

  const PREDEFINED_COLLECTIONS_FOR_SUGGESTION = [];
  // if (Object.keys(ALL_COLLECTION_MAPPINGS_FROM_JS).length > 0) {
  //   for (const url in ALL_COLLECTION_MAPPINGS_FROM_JS) {
  //     if (ALL_COLLECTION_MAPPINGS_FROM_JS.hasOwnProperty(url)) {
  //       let name = ALL_COLLECTION_MAPPINGS_FROM_JS[url];
  //       if (
  //         typeof name === "string" &&
  //         name.startsWith('"') &&
  //         name.endsWith('"')
  //       ) {
  //         name = name.substring(1, name.length - 1);
  //       }
  //       PREDEFINED_COLLECTIONS_FOR_SUGGESTION.push({
  //         name: name,
  //         url: url,
  //         type: "Collection",
  //       });
  //     }
  //   }
  // }

  function addCollectionsWithGender(mappings, genderType) {
    for (const url in mappings) {
      if (mappings.hasOwnProperty(url)) {
        let name = mappings[url];
        if (
          typeof name === "string" &&
          name.startsWith('"') &&
          name.endsWith('"')
        ) {
          name = name.substring(1, name.length - 1);
        }
        PREDEFINED_COLLECTIONS_FOR_SUGGESTION.push({
          name: name,
          url: url,
          type: "Collection",
          gender: genderType, // Tambahkan properti gender di sini
        });
      }
    }
  }

  if (window.MEN_CATEGORY_COLLECTION_MAPPING) {
    addCollectionsWithGender(window.MEN_CATEGORY_COLLECTION_MAPPING, "Men");
  }
  if (window.MEN_SUBCATEGORY_COLLECTION_MAPPING) {
    addCollectionsWithGender(window.MEN_SUBCATEGORY_COLLECTION_MAPPING, "Men");
  }
  if (window.WOMEN_CATEGORY_COLLECTION_MAPPING) {
    addCollectionsWithGender(window.WOMEN_CATEGORY_COLLECTION_MAPPING, "Women");
  }
  if (window.WOMEN_SUBCATEGORY_COLLECTION_MAPPING) {
    addCollectionsWithGender(
      window.WOMEN_SUBCATEGORY_COLLECTION_MAPPING,
      "Women"
    );
  }
  if (window.BOYS_COLLECTION_MAPPING) {
    // Pastikan mapping ini ada
    addCollectionsWithGender(window.BOYS_COLLECTION_MAPPING, "Boys");
  }
  if (window.GIRLS_COLLECTION_MAPPING) {
    // Pastikan mapping ini ada
    addCollectionsWithGender(window.GIRLS_COLLECTION_MAPPING, "Girls");
  }

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  function displayManualResults(
    textSuggestions,
    productHits,
    isLoadingProducts
  ) {
    const resultsContainer =
      document.getElementById(resultsContainerId) ||
      createResultsContainerElement();
    if (!resultsContainer) return;

    let textSuggestionsHTML = "";
    if (textSuggestions && textSuggestions.length > 0) {
      let ulText = '<ul style="list-style-type: none; margin: 0; padding: 0;">';
      textSuggestions.forEach((suggestion) => {
        let flagHTML = "";
        let flagGender = "";
        if (suggestion.type === "Collection") {
          flagHTML = `<span style="font-size: 0.8em; color: #777; background-color: #f0f0f0; padding: 2px 5px; border-radius: 3px; margin-left: 10px; white-space: nowrap;">Collection</span>`;
        }
        if (suggestion.gender) {
          flagGender = `<span style="font-size: 0.8em; color: #777; background-color: #f0f0f0; padding: 2px 5px; border-radius: 3px; margin-left: 10px; white-space: nowrap;">${suggestion.gender}</span>`;
        }
        ulText += `<li style="padding: 10px 15px; cursor: pointer; border-bottom: 1px solid #f0f0f0; font-size: 0.95em; display: flex; justify-content: space-between; align-items: center;" data-url="${
          suggestion.url
        }" data-name="${suggestion.name}" data-type="${
          suggestion.type
        }" data-gender="${suggestion.gender || ""}">
                        <span>${suggestion.name} ${flagGender}</span>
                        <div>${flagHTML}</div>
                       </li>`;
      });
      ulText += "</ul>";
      textSuggestionsHTML = `<div class="manual-search-text-suggestions-section">${ulText}</div>`;
    }

    let productsHTML = "";
    if (isLoadingProducts) {
      productsHTML =
        '<div class="manual-search-loading" style="padding: 20px; text-align: center; color: #777; font-style: italic;">Loading products...</div>';
    } else if (productHits && productHits.length > 0) {
      let ulProducts =
        '<ul style="list-style-type: none; margin: 0; padding: 0;">';
      productHits.forEach((hit) => {
        let imageUrl =
          "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format.webp&v=1530129081";
        if (hit.image && typeof hit.image === "string") imageUrl = hit.image;
        else if (hit.image && hit.image.src) imageUrl = hit.image.src;
        else if (hit.images && hit.images.src) imageUrl = hit.images.src;
        else if (
          hit.meta &&
          hit.meta.product &&
          hit.meta.product.product_images &&
          hit.meta.product.product_images[0]
        )
          imageUrl = hit.meta.product.product_images[0];

        const title = hit.title || "Untitled Product";
        const vendor = hit.vendor || "";
        const productUrl =
          hit.url || (hit.handle ? `/products/${hit.handle}` : "#");

        ulProducts += `<li style="border-bottom: 1px solid #f0f0f0;">
                            <a href="${productUrl}" style="display: flex; align-items: center; padding: 10px 15px; text-decoration: none; color: #333;">
                                <img src="${imageUrl}" alt="${title}" style="width: 50px; height: 50px; margin-right: 15px; object-fit: contain; border: 1px solid #eee;">
                                <div>
                                    <div style="font-weight: 600; font-size: 1em; margin-bottom: 3px;">${title}</div>
                                    ${
                                      vendor
                                        ? `<div style="font-size: 0.85em; color: #666;">${vendor}</div>`
                                        : ""
                                    }
                                </div>
                            </a>
                           </li>`;
      });
      ulProducts += "</ul>";

      const productsHeader = `<div style="padding: 10px 15px 5px 15px; font-weight: bold; color: #333; font-size: 0.9em; background-color: #f9f9f9;">Products</div>`;
      productsHTML = productsHeader + ulProducts;
    } else if (productHits && productHits.length === 0) {
      productsHTML =
        '<div class="manual-search-no-results" style="padding: 15px; text-align: center; color: #777;">No products found.</div>';
    }

    resultsContainer.innerHTML = textSuggestionsHTML;
    if (textSuggestionsHTML && (productsHTML || isLoadingProducts)) {
      // Tambahkan separator jika ada produk atau sedang loading produk
      resultsContainer.innerHTML +=
        '<hr style="margin: 0; border: none; height: 1px; background-color: #e0e0e0;">';
    }
    resultsContainer.innerHTML += `<div class="manual-search-products-section">${productsHTML}</div>`;

    if (!textSuggestionsHTML && !productsHTML && !isLoadingProducts) {
      resultsContainer.innerHTML =
        '<div class="manual-search-no-results" style="padding: 15px; text-align: center; color: #777;">No results found.</div>';
    }

    if (textSuggestionsHTML || productsHTML || isLoadingProducts) {
      resultsContainer.style.display = "block";
      resultsContainer
        .querySelectorAll(".manual-search-text-suggestions-section li")
        .forEach((li) => {
          li.addEventListener(
            "mouseenter",
            () => (li.style.backgroundColor = "#f9f9f9")
          );
          li.addEventListener(
            "mouseleave",
            () => (li.style.backgroundColor = "transparent")
          );
          li.addEventListener("click", (e) => {
            const targetLi = e.currentTarget;
            const url = targetLi.dataset.url;
            if (url && url !== "#") {
              window.location.href = url;
            }
          });
        });
      resultsContainer
        .querySelectorAll(".manual-search-products-section a")
        .forEach((anchor) => {
          anchor.addEventListener(
            "mouseenter",
            () => (anchor.style.backgroundColor = "#f9f9f9")
          );
          anchor.addEventListener(
            "mouseleave",
            () => (anchor.style.backgroundColor = "transparent")
          );
        });
    } else {
      resultsContainer.style.display = "none";
    }
  }

  function clearManualResults() {
    const resultsContainer = document.getElementById(resultsContainerId);
    if (resultsContainer) {
      resultsContainer.innerHTML = "";
      resultsContainer.style.display = "none";
    }
  }

  function createResultsContainerElement() {
    let container = document.getElementById(resultsContainerId);
    if (!container) {
      container = document.createElement("div");
      container.id = resultsContainerId;
      container.style.position = "absolute";
      container.style.backgroundColor = "white";
      container.style.border = "1px solid #e0e0e0";
      container.style.borderTop = "none";
      container.style.zIndex = "100000";
      container.style.minWidth = searchInputElement.offsetWidth + "px";
      container.style.maxHeight = "400px";
      container.style.overflowY = "auto";
      container.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";

      const formElement = searchInputElement.closest("form");
      if (formElement && formElement.parentNode) {
        const popupDiv = formElement.closest(
          'div[popup-container="search"] > div'
        );
        if (popupDiv) {
          popupDiv.style.position = "relative";
          popupDiv.appendChild(container);
        } else {
          searchInputElement.parentNode.insertBefore(
            container,
            searchInputElement.nextSibling
          );
        }
      } else {
        searchInputElement.parentNode.insertBefore(
          container,
          searchInputElement.nextSibling
        );
      }
    }
    return container;
  }

  let currentTextSuggestions = [];

  function performAlgoliaSearch(query) {
    if (query.trim() === "") {
      clearManualResults();
      currentTextSuggestions = [];
      return;
    }

    const resultsContainer =
      document.getElementById(resultsContainerId) ||
      createResultsContainerElement();
    resultsContainer.style.display = "block";

    const lowerCaseQuery = query.toLowerCase();
    const collectionTextSuggestions =
      PREDEFINED_COLLECTIONS_FOR_SUGGESTION.filter((collection) =>
        collection.name.toLowerCase().includes(lowerCaseQuery)
      ).slice(0, 8);

    currentTextSuggestions = collectionTextSuggestions;

    displayManualResults(currentTextSuggestions, null, true);

    index
      .search(query, {
        hitsPerPage: 3,
        clickAnalytics: true,
      })
      .then(function (responseProduct) {
        displayManualResults(
          currentTextSuggestions,
          responseProduct.hits,
          false
        );
      })
      .catch(function (error) {
        console.error("Algolia API Error (Products):", error);
        displayManualResults(currentTextSuggestions, [], false);
      });
  }

  const debouncedSearch = debounce(performAlgoliaSearch, 300);

  searchInputElement.addEventListener("input", function (event) {
    const queryValue = event.target.value;
    if (queryValue.trim().length > 0) {
      debouncedSearch(queryValue);
    } else {
      const debouncedFunction = debouncedSearch;
      if (debouncedFunction && typeof debouncedFunction.cancel === "function") {
        debouncedFunction.cancel();
      }
      clearManualResults();
      currentTextSuggestions = [];
    }
  });

  searchInputElement.addEventListener("focus", function (event) {
    const queryValue = event.target.value;
    if (queryValue.trim().length > 0) {
      const resultsContainer = document.getElementById(resultsContainerId);
      if (
        !resultsContainer ||
        resultsContainer.style.display === "none" ||
        resultsContainer.innerHTML.trim() === ""
      ) {
        performAlgoliaSearch(queryValue);
      }
    }
  });

  if (searchFormElement) {
    searchFormElement.addEventListener("submit", function (event) {
      event.preventDefault(); // Selalu cegah submit default
      const queryValue = searchInputElement.value;
      const trimmedQuery = queryValue.trim();

      if (trimmedQuery.length > 0) {
        // Jika ada query valid, arahkan ke halaman search Shopify
        clearManualResults(); // Sembunyikan dropdown sebelum redirect
        window.location.href = `${SHOPIFY_SEARCH_URL}?q=${encodeURIComponent(
          trimmedQuery
        )}`;
      } else {
        // Jika query kosong atau hanya spasi, bersihkan input dan hasil, jangan redirect
        searchInputElement.value = ""; // Bersihkan input dari spasi
        clearManualResults();
        currentTextSuggestions = [];
      }
    });
  }

  document.addEventListener("click", function (event) {
    const resultsContainer = document.getElementById(resultsContainerId);
    const isClickInsideSearchInput = searchInputElement.contains(event.target);
    const isClickInsideResults = resultsContainer
      ? resultsContainer.contains(event.target)
      : false;

    if (!isClickInsideSearchInput && !isClickInsideResults) {
      if (resultsContainer && resultsContainer.style.display !== "none") {
        clearManualResults();
      }
    }
  });

  const popupMainContainer = searchInputElement.closest(
    'div[popup-container="search"]'
  );
  const closeButton = popupMainContainer
    ? popupMainContainer.querySelector('span[popup-close="search"]')
    : null;

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      clearManualResults();
      currentTextSuggestions = [];
    });
  }

  if (popupMainContainer) {
    popupMainContainer.addEventListener("click", function (event) {
      if (event.target === popupMainContainer) {
        clearManualResults();
        currentTextSuggestions = [];
      }
    });
  }
});
